module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Ca-Db-Ee-Fb-Ga.01f079ff.png";